export const version = '1.10.1';
export const commitHash = '';
export const gitTag = '';
export const buildDate = '2023-05-31T08:27:44.330';
